/**
 * Origin-validation helpers for the postMessage bridge.
 *
 * `event.origin` is a serialized URL origin: `scheme://host[:port]`, with no
 * trailing slash. Real-world config (env vars, hand-typed lists) routinely
 * sneaks in trailing slashes or whitespace, so we normalize before compare.
 *
 * Internal — not part of the package's public surface.
 */
/** Strip whitespace + a single trailing slash. */
export function normalizeOrigin(origin) {
    const trimmed = origin.trim();
    return trimmed.endsWith('/') ? trimmed.slice(0, -1) : trimmed;
}
/**
 * Whether `origin` is in the allow-list. Empty allow-lists reject everything
 * — there is no "permissive mode". Callers in dev that need wildcard behavior
 * should either include `'*'` explicitly (handled here) or skip the check at
 * a higher level.
 */
export function isAllowedOrigin(origin, allowList) {
    if (allowList.length === 0)
        return false;
    const target = normalizeOrigin(origin);
    for (const entry of allowList) {
        const normalized = normalizeOrigin(entry);
        if (normalized === '*' || normalized === target)
            return true;
    }
    return false;
}
//# sourceMappingURL=origin.js.map